import { cellRenderAdminMessageStatus, cellRenderParseDataAndTimeWithSeconds } from '../../../utils/functions';

/** Список полей */
const sapMetDataGrid = [
  {
    dataField: 'docId',
    caption: 'ID документа',
    dataType: 'string'
  },
  {
    dataField: 'msgCounter',
    caption: 'ID сообщения',
    dataType: 'string'
  },
  {
    dataField: 'msgDateTime',
    caption: 'Время',
    dataType: 'datetime',
    cellRender: cellRenderParseDataAndTimeWithSeconds
  },
  {
    dataField: 'msgId',
    caption: 'Тип',
    dataType: 'number'
  },
  {
    dataField: 'msgDesc',
    caption: 'Описание типа',
    dataType: 'string'
  },
  {
    dataField: 'msgSapId',
    caption: 'msgSapId',
    dataType: 'string'
  },
  {
    dataField: 'status',
    caption: 'Статус',
    dataType: 'number',
    cellRender: cellRenderAdminMessageStatus
  },
  {
    dataField: 'msgReprocessNr',
    caption: 'msgReprocessNr',
    dataType: 'string'
  },
  {
    dataField: 'errorText',
    caption: 'errorText',
    dataType: 'string'
  },
  {
    dataField: 'modDateTime',
    caption: 'Время изменения',
    dataType: 'datetime',
    cellRender: cellRenderParseDataAndTimeWithSeconds
  }
];

export default sapMetDataGrid;
